import React, { PureComponent } from "react";

class CustomInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {value: '', mirroredValue: ''};
    this._onChange = props.onChange;
    this.handleChange = this.handleChange.bind(this);
  }

  transform = value => value;
  validate = value => true;

  clearSpaces = x => x.replace(/\s/g, "");

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   console.log(
  //     `nextProps.value = [${nextProps.value}]; prevState.value = [${
  //       prevState.value
  //     }]`
  //   );
  //
  //   if (nextProps.value === null) {
  //     return { value: "" };
  //   }
  //
  //   if (prevState.value !== nextProps.value) {
  //     return {
  //       value: nextProps.value
  //     };
  //   }
  //
  //   return null;
  // }

  static getDerivedStateFromProps(nextProps, prevState) {
    // console.log(nextProps.value = [${nextProps.value}]);

    if (typeof nextProps.value === "undefined" || nextProps.value === null) {
      return { value: "" };
    }
    //console.log(prevState.mirroredValue)
    if (prevState.mirroredValue !== nextProps.value) {
      return {
        value: nextProps.value,
        mirroredValue: nextProps.value
      };
    }

    return null;
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   console.log("prevProps.value", prevProps.value);
  //   console.log("prevState.value", prevState.value);
  //
  //   if (this.props.value !== prevProps.value) {
  //     // this.fetchData(this.props.value);
  //     this.setState({ value: this.props.value });
  //   }
  // }

  handleChange(e) {
    let newValue = this.transform(e.target.value);

    if (this.validate(newValue)) {
      this.setState({ value: newValue });

      if (this._onChange) {
        let newEvent = { ...e };
        newEvent.target.value = newValue;
        this._onChange(newEvent);
      }
    }
  }

  render() {
    const {doctype, guide, ...other} = this.props;
    return (
      <input
        {...other}
        value={this.state.value}
        onChange={this.handleChange}
      />
    );
  }
}

export default CustomInput;